import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private dataSubject = new BehaviorSubject<string>('en-US');

  constructor() {}

  // Function to update data
  updateData(data: string) {
    this.dataSubject.next(data);
  }

  // Function to retrieve data as an observable
  getData() {
    return this.dataSubject.asObservable();
  }
}
